export default __webpack_public_path__ + "static/media/error-icon.b191d081.svg";